declare const localization: Record<string, string> | undefined;

export const t = (key: string): string => {
    return localization?.[key] ?? key + '!!!';
};
